module.exports = __webpack_public_path__ + "img/icon_flag_us@2x.9c46050d.png";